module.exports = __webpack_public_path__ + "static/media/smartcoop-logo-inverted.dac08e6e.svg";